import { create } from 'zustand'

// The Companion API has no subscription concept yet. This module isolates the
// entitlement check behind an async interface so a real API call can drop in
// later without touching consumers (PremiumGate, badges, banners).

/** Chargee subscription tiers, see chargee.energy/nl/abonnementen. */
export type SubscriptionTier = 'basis' | 'standaard' | 'premium'
/** 'included' = paid for by easyEnergy; free of charge for their customers. */
export type SubscriptionStatus = 'active' | 'included'

export interface Subscription {
  tier: SubscriptionTier
  status: SubscriptionStatus
}

const TIER_RANK: Record<SubscriptionTier, number> = { basis: 0, standaard: 1, premium: 2 }

/** Higher tiers include everything from the tiers below. */
export function tierIncludes(have: SubscriptionTier, need: SubscriptionTier): boolean {
  return TIER_RANK[have] >= TIER_RANK[need]
}

/** easyEnergy pays the Chargee subscription for its customers: everyone gets premium. */
async function fetchSubscription(): Promise<Subscription> {
  return { tier: 'premium', status: 'included' }
}

interface SubscriptionState {
  subscription: Subscription | null
  loading: boolean
  load: () => Promise<void>
  clear: () => void
}

export const useSubscriptionStore = create<SubscriptionState>((set, get) => ({
  subscription: null,
  loading: false,

  async load() {
    if (get().subscription || get().loading) return
    set({ loading: true })
    try {
      const subscription = await fetchSubscription()
      set({ subscription })
    } finally {
      set({ loading: false })
    }
  },

  clear: () => set({ subscription: null }),
}))
